import { Badge, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const SmartBadge = ({ 
  count, 
  showZero = false,
  showTooltip = true,
  children,
  ...props 
}) => {
  const { i18n } = useTranslation();
  const language = i18n?.resolvedLanguage || i18n?.language || 'en';
  const formatCount = (num) => {
    if (num === 0) return showZero ? '0' : null;
    if (!num && num !== 0) return null;

    if (language.split('-')[0] !== 'en') {
      if (num < 1000) return new Intl.NumberFormat(language).format(num);
      // Keep the existing thresholds and rounding, then express that same
      // amount using local units (for example, 万 or लाख instead of k/m).
      const rounded = num < 100000 ? Number((num / 1000).toFixed(1)) * 1000
        : num < 1000000 ? Math.floor(num / 1000) * 1000
        : Number((num / 1000000).toFixed(1)) * 1000000;
      return new Intl.NumberFormat(language, { notation: 'compact', maximumFractionDigits: 3 }).format(rounded);
    }
    
    if (num < 1000) {
      return num.toString(); // 0-999: полное число
    }
    
    if (num < 100000) {
      // 1,000 - 99,999: формат 1k, 1.1k, 1.2k ... 99.9k
      const thousands = num / 1000;
      if (thousands % 1 === 0) {
        return `${Math.floor(thousands)}k`; // Целое число
      }
      return `${thousands.toFixed(1)}k`; // Дробное число
    }
    
    if (num < 1000000) {
      // 100,000 - 999,999: 100k, 101k, 999k
      return `${Math.floor(num / 1000)}k`;
    }
    
    // 1,000,000+: 1m, 1.1m, 1.5m
    const millions = num / 1000000;
    if (millions % 1 === 0) {
      return `${Math.floor(millions)}m`;
    }
    return `${millions.toFixed(1)}m`;
  };

  const formattedCount = formatCount(count);
  const shape = count >= 1000 ? "circle" : "rectangle";

  if (!formattedCount) {
    return children;
  }

  const badgeContent = (
    <Badge 
      count={formattedCount} 
      shape={shape}
			showZero
      {...props}
    >
      {children}
    </Badge>
  );

  if (showTooltip && count >= 1000) {
    return (
      <Tooltip title={count.toLocaleString(language)}>
        {badgeContent}
      </Tooltip>
    );
  }

  return badgeContent;
};

export default SmartBadge;
